import { useLocation } from 'react-router-dom';

import { useCurrentUser } from '@/hooks/useCurrentUser';
import { RoutePath } from '@/routes/RoutePath';

export const SCREENER_ALL_FACILITIES_PARAM = 'all_facilities';

export const SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT: RoutePath[] = [
  RoutePath.CRMScreenerAllLeads,
  RoutePath.CRMScreenerESign,
  RoutePath.CRMTasks,
  RoutePath.CRMScreenerEfax,
  RoutePath.CRMScreenerPalAuthorizations
];

const useIsScreenerAllFacilitiesSelected = () => {
  const currentUser = useCurrentUser().data;
  const location = useLocation();

  if (
    // If a user only has access to 1 facility, return false since an all
    // facilities view is useless
    !currentUser ||
    (currentUser.user_facility_accesses &&
      currentUser.user_facility_accesses.length < 2)
  ) {
    return false;
  }

  const searchParams = new URLSearchParams(location.search);

  const isMatch =
    SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT.includes(
      location.pathname as RoutePath
    ) && searchParams.get(SCREENER_ALL_FACILITIES_PARAM) === 'true';

  return isMatch;
};

export default useIsScreenerAllFacilitiesSelected;
